import { useState } from 'react'
import { message } from 'antd'
import type { Payment } from '../types/payment.types'

export const usePaymentActions = () => {
    const [selectedPayment, setSelectedPayment] = useState<Payment | null>(null)
    const [isDetailDrawerOpen, setIsDetailDrawerOpen] = useState(false)
    const [isRefundModalOpen, setIsRefundModalOpen] = useState(false)

    const handleViewDetails = (payment: Payment) => {
        setSelectedPayment(payment)
        setIsDetailDrawerOpen(true)
    }

    const handleOpenRefund = (payment: Payment) => {
        setSelectedPayment(payment)
        setIsRefundModalOpen(true)
    }

    // This function will be called by the form onFinish
    const handleProcessRefund = (values: any) => {
        console.log('Refunding payment:', selectedPayment?.id, values)
        message.success(`Refund of ₹${values.refundAmount} processed successfully!`)
        setIsRefundModalOpen(false)
        setIsDetailDrawerOpen(false)
    }
    
    const closeDrawer = () => setIsDetailDrawerOpen(false)
    const closeRefundModal = () => setIsRefundModalOpen(false)

    return {
        selectedPayment,
        isDetailDrawerOpen,
        isRefundModalOpen,
        handleViewDetails,
        handleOpenRefund,
        handleProcessRefund,
        closeDrawer,
        closeRefundModal
    }
}
